import React from 'react';
import { signOut } from 'firebase/auth';
import { auth } from '../../backend/firebase';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setUid, selectAssignedColor, selectAssignedColorRgb } from '../../redux/features/auth/slice';
import { colorToHex } from '../../redux/features/color/color';
import { track } from '../../helpers/analytics';
import { t } from '../../i18n';
import './ProfileModal.scss';

interface ProfileModalProps {
    email: string | null;
    photoURL: string | null;
    displayName: string | null;
    onClose: () => void;
}

const ProfileModal = ({ email, photoURL, displayName, onClose }: ProfileModalProps) => {
    const dispatch = useAppDispatch();
    const assignedColor = useAppSelector(selectAssignedColor);
    const assignedColorRgb = useAppSelector(selectAssignedColorRgb);

    const handleSignOut = async () => {
        try {
            track('sign_out');
            await signOut(auth);
            dispatch(setUid(null));
            onClose();
        } catch (err) {
            console.error('Sign-out error:', err);
        }
    };

    return (
        <div className="profile-modal" onClick={onClose}>
            <div className="profile-modal__content" onClick={e => e.stopPropagation()}>
                <button className="profile-modal__btn-close" onClick={onClose} aria-label={t('web.common.close')}>✕</button>
                {photoURL
                    ? <img className="profile-modal__avatar" src={photoURL} alt={displayName ?? t('web.auth.profile')} referrerPolicy="no-referrer" />
                    : <div className="profile-modal__avatar profile-modal__avatar--initials">
                        {(displayName ?? email ?? '?')[0].toUpperCase()}
                      </div>
                }
                {displayName && <p className="profile-modal__name">{displayName}</p>}
                <p className="profile-modal__email">{email}</p>
                {assignedColor && assignedColorRgb && (
                    <div className="profile-modal__color-chip">
                        <span className="profile-modal__color-swatch" style={{ backgroundColor: colorToHex(assignedColorRgb) }} />
                        <span className="profile-modal__color-name">
                            {assignedColor.charAt(0).toUpperCase() + assignedColor.slice(1)}
                        </span>
                    </div>
                )}
                <button className="profile-modal__btn-signout" onClick={handleSignOut}>
                    {t('web.auth.signOut')}
                </button>
            </div>
        </div>
    );
};

export default ProfileModal;
